/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import { isPlanAvailable } from 'redux-app/utils/subscription'

export const getData = state => state.subscriptions
export const getSubscriptionPlans = state => getData(state).subscriptionPlans
export const getSubscriptionPlansForRenew = state => getData(state).renewalPlans
export const getSelectedPlanId = state => getData(state).selectedPlanId
export const getSelectedPlan = state => getSubscriptionPlans(state)
.find(item => item.id === getSelectedPlanId(state))
export const getSelectedPlanForRenew = state => getSubscriptionPlansForRenew(state)
  .find(item => item.id === getSelectedPlanId(state))
export const getSelectedPlanName = state => _get(getSelectedPlan(state), 'name')
export const getSelectedPlanPrice = state => {
  const activationFee = _get(getSelectedPlan(state), 'activationFee')
  const price = _get(getSelectedPlan(state), 'price')

  if (!activationFee) {
    return price
  }

  return activationFee + price
}
export const isSelectedPlanAvailable = state => isPlanAvailable(getSelectedPlan(state))
